<template lang="pug">
.question-new
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/service_question") {{ $t('Service Questions')}}
    li
      router-link(to="/service_question/questions") {{ $t('Service Questions List') }}
    li.active
      span {{ $t('Service Questions New') }}

  //- タイトル
  h2(style="text-align: center;") {{ $t('Service Questions New') }}

  form.form-horizontal
    .row.margin-top
      label.col-sm-3.control-label タイトル
      .col-sm-9
        input.form-control(type="text", v-model="title", v-bind:class="{required: !validation.title }")
        p.validation-msg(v-show="!validation.title") {{ $t('validations.required') }}
    .row.margin-top
      label.col-sm-3.control-label 接客評価
      .col-sm-9
        select.form-control(v-model="masterServiceQuestionId", v-bind:class="{required: !validation.masterServiceQuestionId }")
          option
          option(v-for="masterServiceQUestion in masterServiceQuestions" v-bind:value="masterServiceQUestion.id") {{ masterServiceQUestion.title }}
        p.validation-msg(v-show="!validation.masterServiceQuestionId") {{ $t('validations.required') }}
    
    template
      .row.margin-top
        label.col-sm-3.control-label 評価者
        .col-sm-9
          input(type='checkbox', v-model="serviceQuestionUserTypeAllCheck", v-on:click="serviceQuestionUserTypeAllChecked", style="margin-right: 5px;", id="service-question-user-type-all-check") 
          label(for="service-question-user-type-all-check") 全選択
      .row
        .col-sm-3
        .col-sm-9
          .row.margin-top
            .col-sm-4(v-for="(userType, index) in userTypes")
              input(type='checkbox', v-model="serviceQuestionUserTypeIds", v-bind:value="userType.id", style="margin-right: 5px;",
              :id="'service-question-user-type_' + index") 
              label(:for="'service-question-user-type_' + index") {{ userType.attributes['user-type-name'] }}
          p.validation-msg(v-show="!validation.serviceQuestionUserTypeIds") {{ $t('validations.check') }}
    
    template
      .row.margin-top
        label.col-sm-3.control-label 評価対象者
        .col-sm-9
          input(type='checkbox', v-model="serviceQuestionTargetUserTypeAllCheck", v-on:click="serviceQuestionTargetUserTypeAllChecked", style="margin-right: 5px;", id="service-question-target-user-type-all-check") 
          label(for="service-question-target-user-type-all-check") 全選択
      .row
        .col-sm-3
        .col-sm-9
          .row.margin-top
            .col-sm-4(v-for="(userType, index) in userTypes")
              input(type='checkbox', v-model="serviceQuestionTargetUserTypeIds", v-bind:value="userType.id", style="margin-right: 5px;",
              :id="'service-question-target-user-type_' + index") 
              label(:for="'service-question-target-user-type_' + index") {{ userType.attributes['user-type-name'] }}
          p.validation-msg(v-show="!validation.serviceQuestionTargetUserTypeIds") {{ $t('validations.check') }}
    .row.margin-top
      label.col-sm-3.control-label 自己評価
      .col-sm-3
        input(type='checkbox', v-model="isOwn", style="margin-right: 5px;", id="is-own-check") 
        label(for="is-own-check") 自己評価する
    .row.margin-top
      label.col-sm-3.control-label 公開日
      .col-sm-9
        el-date-picker(v-model="openDate" placeholder="公開日")
        p.validation-msg(v-show="!validation.openDateRange || !validation.openDate") 当日以降の日付を選択してください。
    .row.margin-top
      label.col-sm-3.control-label 公開終了日
      .col-sm-9
        el-date-picker(v-model="closeDate" placeholder="公開終了日")
        p.validation-msg(v-show="!validation.closeDateRange") 公開終了日は公開日以後の日付を入力してください。
    .row.margin-top
      label.col-sm-3.control-label 回答開始日
      .col-sm-9
        .sort-card__select-wrap
          select.form-control(v-model="answerStartDay")
            option(v-for="day in days" v-bind:value="day") 毎月{{ day }}日から回答可能
    .row.margin-top
      label.col-sm-3.control-label 入社日条件
      .col-sm-9
        .form-inline
          input(type="number", v-model="targetJoinDay", min="0", style="width: 80px; margin-right: 5px;")
          span 日前以上前に入社した従業員を対象とする
    .row.margin-top
      label.col-sm-3.control-label 対象者の在籍日
      .col-sm-9
        .sort-card__select-wrap
          select.form-control(v-model="targetDay")
            option(v-for="day in days" v-bind:value="day") 毎月{{ day }}日時点の在籍者が対象
    .row.margin-top
      .col-sm-12.text-right
        a.btn.btn-info(style="margin-right: 5px;", v-on:click="onClickSave()", v-bind:class="{disabled: !validation.notInput}")
          i.fa.fa-floppy-o
          span {{ $t('Save') }}
        a.btn.btn-danger(v-on:click="onClickCancel()")
          i.fa.fa-close
          span {{ $t('Cancel') }}
</template>
<script>
import AppHeader from './AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'service-question-new',
  created () {
    this.$store.dispatch('USERTYPE_ALL_GET', {})
    this.getMasterServiceQuestions()
  },
  data () {
    return {
      title: '',
      masterServiceQuestionId: null,
      masterServiceQuestions: [],
      isOwn: false,
      serviceQuestionUserTypeAllCheck: false,
      serviceQuestionUserTypeIds: [],
      serviceQuestionTargetUserTypeAllCheck: false,
      serviceQuestionTargetUserTypeIds: [],
      openDate: '',
      closeDate: '',
      answerStartDay: 25,
      targetJoinDay: null,
      targetDay: 1,
      closeDateRange: this.openDateFormat < this.closeDateFormat,
      canValidate: true,
      savingFlag: false,
      days: [...Array(31)].map((_, i) => i + 1)
    }
  },
  computed: {
    openDateFormat () {
      return DayJs(this.openDate).format('YYYY-MM-DD')
    },
    closeDateFormat () {
      return this.closeDate ? DayJs(this.closeDate).format('YYYY-MM-DD') : null
    },
    validation: function () {
      const today = DayJs(new Date()).format('YYYY-MM-DD')
      var v = {
        title: !!this.title,
        masterServiceQuestionId: !!this.masterServiceQuestionId,
        openDate: !!this.openDate,
        openDateRange: today <= this.openDateFormat,
        closeDateRange: !this.closeDate || this.openDateFormat < this.closeDateFormat,
        serviceQuestionUserTypeIds: this.serviceQuestionUserTypeIds.length > 0,
        serviceQuestionTargetUserTypeIds: this.serviceQuestionTargetUserTypeIds.length > 0,
        notInput: !!this.title && !!this.masterServiceQuestionId && !!this.openDate &&
        !!this.answerStartDay && !!this.targetDay &&
        this.serviceQuestionUserTypeIds.length > 0 &&
        this.serviceQuestionTargetUserTypeIds.length > 0
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    userTypes () {
      return this.$store.getters.usertypesAll
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getMasterServiceQuestions () {
      let data = {}
      await this.$store.dispatch('GET_MASTER_SERVICE_QUESTION_ALL', { data })
      .then(res => {
        this.masterServiceQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('SERVICE_QUESTION_CREATE', {
        data: {
          title: this.title,
          master_service_question_id: this.masterServiceQuestionId,
          is_own: this.isOwn,
          open_date: this.openDateFormat,
          close_date: this.closeDateFormat,
          answer_start_day: this.answerStartDay,
          target_join_day: this.targetJoinDay,
          target_day: this.targetDay,
          service_question_user_type_ids: this.serviceQuestionUserTypeIds,
          service_question_target_user_type_ids: this.serviceQuestionTargetUserTypeIds
        }
      })
      .then(res => {
        this.$router.push({path: '/service_question/questions'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push({path: '/service_question/questions'})
    },
    serviceQuestionUserTypeAllChecked: function () {
      this.serviceQuestionUserTypeIds = this.serviceQuestionUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    },
    serviceQuestionTargetUserTypeAllChecked: function () {
      this.serviceQuestionTargetUserTypeIds = this.serviceQuestionTargetUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// ServiceQuestionNew.vue?0cc62e61